import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import kehilaMigrationWizardStore from 'store/kehilaMigrationWizard.store'
import { RowSplit, KeyButton, Cards, Card, Note, Banner } from '../KehilaMigrationWizard.styles'

const CreateCategoriesStep: FC = () => {
  const store = kehilaMigrationWizardStore
  const { t } = useTranslation('kehilaMigration')
  const result = store.createResult

  return (
    <>
      <RowSplit>
        <KeyButton disabled={store.creatingCategories} onClick={store.createCategories}>
          {store.creatingCategories ? t`create_creating` : t('create_button', { num: store.liveCategories.length })}
        </KeyButton>
      </RowSplit>
      {result ? (
        <>
          <Cards>
            <Card><div className='l'>{t`create_created`}</div><div className='n'>{result.created}</div></Card>
            <Card><div className='l'>{t`create_reused`}</div><div className='n'>{result.reused}</div></Card>
          </Cards>
          <Note style={{ display: 'block', marginTop: 12 }}>{t`create_written`}</Note>
        </>
      ) : (
        <Banner>
          {t`create_banner`}
        </Banner>
      )}
    </>
  )
}

export default observer(CreateCategoriesStep)
